const initialState = {
  activeStep: null
};

export default function layout(state = initialState, action) {
  let newState = Object.assign({}, state);

  switch (action.type) {
    case "SET_LAYOUT_ACTIVE_STEP_TO_ZERO":
      newState.activeStep = 0;

      break;

    default:
      return state;
  }

  return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/layout.reducer.js